export type PoolValue = {
  store_value: string;
  store_label: string;
  pool_value: string;
  match: string;
  ignored?: boolean;
  ignored_reason?: string | null;
};

export type ValueAction = "pick" | "keep" | "ignore";

const CHECK = "⚠ please check";
const NOT_CHECKED = "not checked — model call failed; refresh values to retry";
const NOT_IN_LIST = "not in this closed list — cannot be saved";

export function valueView(value: PoolValue, hasFix = false) {
  const closed = value.match === "not in list";
  const notChecked = value.match === "not checked";
  const doubtful = value.match === "ai" || value.match === "new";
  return {
    note: hasFix
      ? null
      : closed
        ? NOT_IN_LIST
        : notChecked
          ? NOT_CHECKED
          : doubtful
            ? CHECK
            : null,
    actions: (closed
      ? ["ignore"]
      : ["pick", "keep", "ignore"]) as ValueAction[],
  };
}

export const hasNotChecked = (values: PoolValue[]) =>
  values.some((value) => value.match === "not checked" && !value.ignored);

export const canPickAgain = (value: PoolValue) =>
  Boolean(value.ignored) && value.ignored_reason === "not checked";
